import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './components/App/App';
import { createApplicationStore } from './store';
import { ErrorEffects } from './effects/errorEffects';
import { consumeAuthCallbackParams } from './effects/authCallbackParams';

const init = async() => {
  const el = document.getElementById('root');
  const store = createApplicationStore({});
  const root = createRoot(el!);

  // Before the router mounts — it strips the query string these params arrive in.
  consumeAuthCallbackParams(store.dispatch);

  root.render(
      <Provider store={store} >
        <App />
      </Provider>
  );

  window.addEventListener('error', (event) => {
    ErrorEffects.logError(event.error)
  });
  window.addEventListener('unhandledrejection', (event) => {
    ErrorEffects.logError(event.reason)
  });

 /* if (isProduction()) {
    (function() {
      var ga4 = document.createElement('script'); ga4.type = 'text/javascript'; ga4.async = true;
      ga4.src = 'https://www.googletagmanager.com/gtag/js?id=' + getGa4Id();
      document.getElementsByTagName('body')[0].append(ga4);
      //@ts-ignore
      window.dataLayer = window.dataLayer || [];
      //@ts-ignore
      function gtag(){dataLayer.push(arguments);}
      //@ts-ignore
      gtag('js', new Date());
      //@ts-ignore
      gtag('config', getGa4Id());
    })();
  }*/
};
init();
